import router from '../../router'
const state = {
  'access_token': localStorage.getItem('access_token') || ''
}

const getters = {
  isLoggedIn: state => !!state['access_token']
}

const mutations = {
  set_token (store, data) {
    store['access_token'] = data
    localStorage.setItem('access_token', data)
  },
  logout (store) {
    localStorage.removeItem('access_token')
    store['access_token'] = ''
  }
}

const actions = {
  async login ({ commit, dispatch }, data) {
    try {
      console.log('TCL: login -> this', this._vm)
      const loginRes = await this._vm.$_services.auth.login(data)
      console.log('TCL: login -> user', loginRes.data['access_token'])
      commit('set_token', loginRes.data['access_token'])
      return loginRes
    } catch (error) {
      console.log('TCL: actions -> login -> catch -> error', error.response)
      return Promise.reject(error)
    }
  },
  logout ({ commit }) {
    this._vm.$_services.auth.logout()
    commit('logout')
    commit('user/reset_my_user_info', null, { root: true })
    router.push('/welcome')
  }
}

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
}
